import React, {useState, useEffect} from "react";
import ContentViewer from "./ContentViewer";
import { showToast } from "./Messages";
import { dateFormat } from "../libs/Util";
import EditorViewer from "./EditorViewer";
const SearchDocument = (props) => {
    const [keyword, setKeyword] = useState(props.keyword || "");
    const [docList, setDocList] = useState([]);
    const [subDocList, setSubDocList] = useState([]);
    const [selectList, setSelectList] = useState([]);
    const [selectedIndex, setSelectedIndex] = useState(-1);
    const [contentViewer, setContentViewer] = useState(null);
    const [editorData, setEditorData] = useState(null);
    const [menuModules, setMenuModules] = useState(null);
    const [localDocuments, setLocalDocuments] = useState(props.documents || []);
    const [isSubDocList, setIsSubDocList] = useState(false);
    const [sortType, setSortType] = useState(1);
    const from = props.from || "";
    const type = props.type || "";

    useEffect(() => {
        if(from === "template") {
            getTemplateList();
        } else if (from === "faq") {
            getFaqList();
        } else {
            searchDocument();
        }
    }, [from]);

    useEffect(() => {
        if (selectList.length > 0 && selectedIndex > -1 && selectedIndex < selectList.length) {
            if(from === "template")
                setEditorData(selectList[selectedIndex].contentJson);
            else if (from === "faq") {
                setEditorData(`{"data":${selectList[selectedIndex].answer}}`);
            }
            else 
                getManual(selectList[selectedIndex].docId);  
            if (from !== "faq")
                getMenuModulesByDocumentId(selectList[selectedIndex].docId);
        }
    }, [selectList, selectedIndex]);
    
    useEffect(() => {
        if (docList.length > 0) {
            if(from === "menu") {
                docList.forEach(item => {
                    if(!item.docId) {
                        const doc = JSON.parse(item.documents)[0];
                        item.docId = doc.docId;
                        item.docBoxPath = doc.docBoxPath;
                    }
                })
            }
            setSelectList(docList);
        }
    }, [docList]);

    useEffect(() => {
        setSelectedIndex(-1);
        if(subDocList.length > 0) {
            setSelectList(subDocList);
            setIsSubDocList(true);
        } else {
            setSelectList(docList);
            setIsSubDocList(false);
        }
    }, [subDocList]);

    useEffect(() => {
        if (editorData) {
            if (selectList.length > 0 && selectedIndex > -1 && selectedIndex < selectList.length) {
                if (from === "faq") {
                    setContentViewer(
                        <ContentViewer
                            ContentInfo={{ name: selectList[selectedIndex].question, item: { documents: [], manualId: '' }, path: [] }}
                            docId={selectList[selectedIndex].faqID}
                            editorData={editorData}
                            folderItemList={[]}
                            devUserId=''
                            class={""}
                        />
                    );
                } else
                setContentViewer(
                    <ContentViewer
                        ContentInfo={{ name: selectList[selectedIndex].title, item: { documents: [], manualId: '' }, path: [] }}
                        docId={selectList[selectedIndex].docId}
                        editorData={editorData}
                        folderItemList={[]}
                        devUserId=''
                        class={selectList[selectedIndex].docBoxPath}
                    />
                );
            }
        } else {
            setContentViewer('문서를 찾을 수 없습니다.');
        }
    }, [editorData]);

    const handleInputChange = (e, item) => {
        const { name, value, checked } = e.target;
        if (name === 'keyword') {
            setKeyword(value);
        } else if (name === 'listCheck') {
            if (checked) {
                addItem(item);
            } else {
                removeItem(item);
            }
        }
    };

    const handleSortChange = (e) => {
        const sortType = e.target.value;
        let sortedList = [...selectList];

        if (sortType === "1") {
            // 최신순
            sortedList.sort((a, b) => new Date(b.updateDateTime) - new Date(a.updateDateTime));
        } else if (sortType === "2") {
            // 오래된순
            sortedList.sort((a, b) => new Date(a.updateDateTime) - new Date(b.updateDateTime));
        } else if (sortType === "3") {
            // 오름차순
            sortedList.sort((a, b) => a.title.localeCompare(b.title, "ko"));
        } else if (sortType === "4") {
            // 내림차순
            sortedList.sort((a, b) => b.title.localeCompare(a.title, "ko"));
        }
        setSortType(sortType);
        setSelectList(sortedList);
    };

    const getManual = async (docId) => {
        var body = JSON.stringify({
            DocumentNo: docId
        });
        if (docId !== '') {
            const response = await fetch('api/Document/Manual', {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json; charset=utf-8'
                },
                body: body
            });
            const result = await response.json();
            setEditorData(result);
        }
    }

    const getMenuModulesByDocumentId = async (docId) => {
        var body = JSON.stringify({
            DocumentNo: docId
        });
        if (docId !== '') {
            const response = await fetch(`api/Document/GetMenuModulesByDocumentId?docId=${docId}`, {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json; charset=utf-8'
                },
                body: body
            });
            const result = await response.json();
            setMenuModules(result.table);
        }
    }

    const searchDocument = async () => {
        if (from === "faq") {
            getFaqList();
            return;
        }
        const route = from === "menu" ? 'Edit' : 'Document'
        const body = {
            keyword: keyword,
            sortType: sortType
        }
        const response = await fetch(`api/${route}/SearchDocument?searchText=${keyword}&sortType=${sortType}`, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json; charset=utf-8'
            },
            body: JSON.stringify(body)
        });
        const result = await response.json();
        if (response.status === 200 && result.message === "Success") {
            if (type !== "copy") setSelectedIndex(0);
            if(result.data.table)
                setDocList(result.data.table);
            else
                setDocList(result.data);
        } else {
            showToast('danger', "문서 조회를 실패했습니다.");
        }
    };

    const getTemplateList = async () => {
        const response = await fetch('api/Edit/GetTemplateList', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json; charset=utf-8'
            },
        });
        const result = await response.json();
        if(response.status === 200 && result.data) {
            if(result.data?.table.length === 0) {
                showToast('danger', "템플릿이 존재하지 않습니다.");
            }
            setDocList(result.data?.table || []);
        }
    }

    const getFaqList = async () => {

        const response = await fetch('api/Edit/GetFaqList', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json; charset=utf-8'
            },
            body: JSON.stringify({keyword: keyword})
        });
        const result = await response.json();
        if(response.status === 200 && result.data) {
            if(result.data?.table.length === 0) {
                showToast('danger', "FAQ가 존재하지 않습니다.");
            }
            setDocList(result.data?.table || []);
        }
    }

    const addItem = (item) => {
        if (localDocuments) {
            const keyId = from === "faq" ? "faqID" : from !== "menu" ? "docId" : "manualId";
            const exists = localDocuments.some((dataItem) => dataItem[keyId] === item[keyId]);
            if (exists) return;

            const type = from === "faq" ? "faq" : from !== "menu" ? null : "relationInfo";

            let newItem = {};
            if (from === "faq") {
                newItem = {
                    question: item.question,
                    faqKindName: item.faqKindName,
                    faqID: item.faqID
                };
            } else if (from !== "menu") {
                const tag = item.tag ? item.tag : "[]";
                newItem = {
                    title: item.title,
                    docBox: item.docBox,
                    docBoxPath: item.docBoxPath,
                    docId: item.docId,
                    version: item.version,
                    access: item.access,
                    tag: JSON.parse(tag)
                };
            } else {
                newItem = {
                    title: item.title,
                    manualId: item.manualId,
                    menuPath: item.menuPath,
                    fullPath: item.fullPath,
                    documents: item.documents
                };
            }
            setLocalDocuments((prevDocuments) => [...prevDocuments, newItem]);
            if (type)
                props.addItem(newItem, type);
            else 
                props.addItem(newItem);
        }
    };

    const removeItem = (item) => {
        if (localDocuments) {
            const keyId = from === "faq" ? "faqID" : from !== "menu" ? "docId" : "manualId";
            const type = from === "faq" ? "faq" : from !== "menu" ? null : "relationInfo";
            setLocalDocuments((prevDocuments) =>
                prevDocuments.filter((data) => data[keyId] !== item[keyId])
            );
            if (type)
                props.removeItem(item, type);
            else
                props.removeItem(item);
        }
    };

    const getSubList = async (e, menu) => {
        e.preventDefault();
        e.stopPropagation();
        if(!menu.documents || menu.documents === "") {
            showToast("danger", "메뉴에 연결된 문서가 존재하지 않습니다.");
            return;
        }
        const response = await fetch(`api/Edit/GetDocumentListByMenuModule`, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json; charset=utf-8'
            },
            body: JSON.stringify({
                manualId: menu.manualId
            })
        });
        const result = await response.json();
        if (response.status === 200 && result.message === "Success") {
            if(result.data.table)
                setSubDocList(result.data.table);
            else
                setSubDocList(result.data);
        } else {
            showToast('danger', "문서 조회를 실패했습니다.");
        }
    };

    const copyDocument = (e, docData, docId) => {
        e.preventDefault();
        e.stopPropagation();
        props.pasteDocumentData(docData, docId);
    };

    return (
        <div className="msg-popup admin-user-info">
            <div className="box h-800">
                <div className="title-wrap">
                    <p className="modal-title">{`${type === "copy" ? "가져올" : "연결할"} 문서 선택`}</p>
                    <button className='btn-close' onClick={(e) => props.fnBtnOnPopup(e, null)}><i className='icoKdc32 close'></i></button>
                </div>
                <div className='doc-link-cnts'>
                    <div className='doc-link-cnts-left'>
                        <div className="doc-search">
                            <input className="search-input" name="keyword" value={keyword} onChange={handleInputChange} onKeyUp={(e) => { e.key === 'Enter' && searchDocument(); }} placeholder='문서 검색' />
                            <i className="icoKdc32 magnifier-32" onClick={(e) => searchDocument()} ></i>
                        </div>
                        <div className='doc-link-list-top'>
                            <p className='result'>검색결과 <span>{(docList && docList.length > 0 ? docList.length.toString() : 0)}</span>개</p>
                            <div className="select-wrap">
                                <select className="ctgr-select" id="ctgrSelect" onChange={handleSortChange}>
                                    <option value="1">최신순</option>
                                    <option value="2">오래된순</option>
                                    <option value="3">오름차순</option>
                                    <option value="4">내림차순</option>
                                </select>
                            </div>
                        </div>
                        <ul className='doc-link-list-wrap'>
                            {type !== "copy" ? (
                                selectList.map((item, i) => (
                                    <CheckBoxItem i={i} item={item} selectedIndex={selectedIndex} setSelectedIndex={setSelectedIndex} from={from} localDocuments={localDocuments} handleInputChange={handleInputChange} />
                                ))
                            )
                            : (
                                <>
                                    {isSubDocList &&
                                        <div onClick={() => setSubDocList([])} style={{padding: "15px 10px", cursor: "pointer"}}>
                                            <i className="icoKdc16 expand" style={{transform: "rotate(-90deg)"}}></i>
                                        </div>
                                    }
                                    {selectList.map((item, i) => (
                                        <SingleItem i={i} item={item} selectedIndex={selectedIndex} setSelectedIndex={setSelectedIndex} from={from} localDocuments={localDocuments} handleInputChange={handleInputChange} copyDocument={copyDocument} hasSub={item.documents} getSubList={getSubList} />
                                    ))}
                                </>
                            )}
                        </ul>
                    </div>
                    <div className='doc-link-cnts-preview'>
                        {menuModules && menuModules.length > 0 &&
                        <div className='doc-link-preview-div'>
                            <div className='doc-link-title-wrap'>
                                <i className='icoKdc24 doc-link-info'></i>
                                <p className='div-title'>문서 게시정보</p>
                            </div>
                            <ul className='doc-info-wrap'>
                                {menuModules && menuModules.length > 0 ? (
                                    menuModules.map((item, index) => (
                                        <li className='doc-info' key={index}>
                                            <div className="doc-info-path">
                                                {JSON.parse(item.fullPath).map((x, i, arr) => (
                                                    <React.Fragment key={i}>
                                                        <span className="path-li">{x}</span>
                                                        {i < arr.length - 1 && <i className="icoKdc12 next"></i>}
                                                    </React.Fragment>
                                                ))}
                                            </div>
                                            <div className='doc-info-btm'>
                                                <p className='doc-info-title'>{item.title}</p>
                                                <p className='doc-info-version'>{item.version}</p>
                                            </div>
                                        </li>
                                    ))
                                ) : (
                                    <li className='doc-info'>게시가 되지 않은 문서입니다.</li>
                                )}
                            </ul>
                        </div>
                        }
                        <div className='doc-link-preview-div'>
                            <div className='doc-link-title-wrap'>
                                <i className='icoKdc24 doc-link-preview'></i>
                                <p className='div-title'>문서 미리보기</p>
                            </div>
                            <div className='doc-preview'>{contentViewer}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SearchDocument;

const CheckBoxItem = (props) => {
    const isChecked = () => {
        const isChecked = 
        props.from === "menu" ?
            props.localDocuments?.some((dataItem) => dataItem.manualId === props.item.manualId)
        :   props.from === "faq" ?
            props.localDocuments?.some((dataItem) => dataItem.faqID === props.item.faqID)
        :
            props.localDocuments?.some((dataItem) => dataItem.docId === props.item.docId)
        return isChecked
    }
    if (props.from === "faq") {
        return (
            <li className={`doc-link-list${props.selectedIndex === props.i ? ' selected' : ''}`} key={props.i} onClick={(e) => props.setSelectedIndex(props.i)}>
                <div className="list-checkbox">
                    <input type="checkbox" name="listCheck" id={`check${props.i}`} checked={isChecked()} onClick={(e) => e.stopPropagation()} onChange={(e) => props.handleInputChange(e, props.item)} />
                    <label htmlFor={`check${props.i}`} onClick={(e) => e.stopPropagation()}></label>
                </div>
                <div className="doc-link-item">
                    <div className={props.hasSub ? "path" : ""}>
                        <span className="path-li">{props.item.faqKindName}</span>
                    </div>
                    <p className='doc-link-item-title'>{props.item.question}</p>
                    <div className='doc-link-item-date'>
                        <span className='date-label'>{`등록일자`}</span>
                        <span className='date'>{dateFormat(new Date(props.item.updateDateTime))}</span>
                    </div>
                </div>
            </li>
        )
    } else {
        return (
            <li className={`doc-link-list${props.selectedIndex === props.i ? ' selected' : ''}`} key={props.i} onClick={(e) => props.setSelectedIndex(props.i)}>
                <div className="list-checkbox">
                    <input type="checkbox" name="listCheck" id={`check${props.i}`} checked={isChecked()} onClick={(e) => e.stopPropagation()} onChange={(e) => props.handleInputChange(e, props.item)} />
                    <label htmlFor={`check${props.i}`} onClick={(e) => e.stopPropagation()}></label>
                </div>
                <div className="doc-link-item">
                    <p className='doc-link-item-title'>{props.item.title}</p>
                    <div className='doc-link-item-date'>
                        <span className='date-label'>{`${props.from === "menu" ? "업데이트" : "검수완료"}일자`}</span>
                        <span className='date'>{dateFormat(new Date(props.item.updateDateTime))}</span>
                    </div>
                </div>
            </li>
        )
    }
}

const textStyle = {
    flexShrink: 0,
    color: "#999",
    fontSize: "14px",
    fontWeight: 500,
    lineHeight: "150%"
}

const SingleItem = (props) => {
    const path = (item) => {
        const pathItem = item.fullPath ? JSON.parse(item.fullPath) : item.docBoxName ? [item.docBoxName] : [];
        let pathlist = [];
        pathItem.map((x,index) => {
            pathlist.push(<span className={'path-li'} style={textStyle}>{x}</span>);                    
                if(index < pathItem.length-1)
                    pathlist.push(<i className='icoKdc12 next'></i>);
                return x;
            }
        );

        return (
            <div className={props.hasSub ? "path" : ""}>
                {pathlist}
            </div>
        );
    }
    const btnStyle = {
        padding: "6px",
        border: "1px solid #ddd",
        borderRadius: "6px",
        background: "transparent",
        cursor: "pointer"
    }
    return (
        <li className={`doc-link-list${props.selectedIndex === props.i ? ' selected' : ''}`} key={props.i} style={{justifyContent: "space-between"}}
            onClick={(e) => !props.hasSub ? props.setSelectedIndex(props.i) : null}>
            <div className="doc-link-item" style={{maxWidth: "300px"}}>
                {props.from !== "template" && path(props.item)}
                <p className='doc-link-item-title'>{props.item.title}</p>
                <div className='doc-link-item-date'>
                    <span className='date-label'>{`${props.from === "menu" || props.from === "template" ? "업데이트" : "검수완료"}일자`}</span>
                    <span className='date'>{props.item.updateDateTime}</span>
                </div>
            </div>
            {props.hasSub ?
                <button className="btn-add" style={btnStyle} onClick={(e) => props.getSubList(e, props.item)}>
                    <i className="icoKdc16 expand" style={{transform: "rotate(90deg)"}}></i>
                </button>
                :
                <button className="btn-add" style={btnStyle} onClick={(e) => props.copyDocument(e, props.item.contentJson, props.from !== "template" ? props.item.docId : null)}>
                    <i className="icoKdc20 add-g"></i>
                </button>
            }
        </li>
    )
}